<template>
  <div
    class="box"
    style="padding-right: 0 !important; min-height: calc(100vh - 100px)"
  >
    <div class="">
      <div class="d-flex">
        <div>
          <santakButton
            title="取消"
            @clickHandle="goIndex"
            isActive="true"
            style="margin: 20px; margin-bottom: 0"
          ></santakButton>
          <santakButton
            title="保存并返回"
            @clickHandle="addNewServer"
            isActive="true"
            style="margin: 20px; margin-bottom: 0"
          ></santakButton>
        </div>
      </div>
      <div class="p-y-3">
        <div class="j-sb" style="flex-wrap: wrap">
          <div class="d-flex a-center" style="margin-bottom: 26px">
            <santakinput
              santakLabel="活动名称"
              labelWidth="116"
              field="queryInfo"
              fieldName="eventName"
              :defaultValue="queryInfo.eventName"
              :isRequired="true"
            ></santakinput>

            <santakinput
              santakLabel="活动ID"
              labelWidth="116"
              field="queryInfo"
              :defaultValue="queryInfo.eventId"
              fieldName="eventId"
              style="margin-left: 150px"
            ></santakinput>
          </div>

          <div class="d-flex a-center" style="margin-bottom: 26px">
            <div
              style="
                text-align: right;
                padding-right: 10px;
                font-size: 0.875rem;
                width: 7.25rem;
              "
            >
              签到开始时间
            </div>
            <el-date-picker
              v-model="queryInfo.startTime "
              type="datetime"
              placeholder="选择开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>

            <santakinput
              santakLabel="活动关联会议ID"
              labelWidth="116"
              field="queryInfo"
              :defaultValue="queryInfo.relationId"
              fieldName="relationId"
              style="margin-left: 150px"
            ></santakinput>
          </div>

          <div class="d-flex a-center" style="margin-bottom: 26px">
            <div
              style="
                text-align: right;
                padding-right: 10px;
                font-size: 0.875rem;
                width: 7.25rem;
              "
            >
              签到结束时间
            </div>
            <el-date-picker
              v-model="queryInfo.endTime"
              type="datetime"
              placeholder="选择结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>

            <santakinput
              field="queryInfo"
              fieldName="sponsor"
              santakLabel="主办方"
              labelWidth="116"
              :defaultValue="queryInfo.sponsor"
              style="margin-left: 150px"
            ></santakinput>
          </div>
          <div class="d-flex a-center" style="margin-bottom: 26px">
            <santakinput
              santakLabel="协办方"
              labelWidth="116"
              field="queryInfo"
              :defaultValue="queryInfo.coOrganizer"
              fieldName="coOrganizer"
            ></santakinput>

            <santakinput
              santakLabel="赞助商"
              labelWidth="116"
              field="queryInfo"
              :defaultValue="queryInfo.organizer"
              style="margin-left: 150px"
              fieldName="organizer"
            ></santakinput>
          </div>
          <div class="d-flex a-center" style="margin-bottom: 26px">
            <santakinput
              santakLabel="活动地址"
              labelWidth="116"
              field="queryInfo"
              :defaultValue="queryInfo.activityAddress"
              fieldName="activityAddress"
              @input.native="addressChange"
            ></santakinput>

            <el-button style="margin-left: 15px" @click="queryLocation"
              >校验位置</el-button
            >
            <div style="margin-left: 110px">
              <span style="margin-right: 15px">纬度</span>
              <el-input
                style="width: 150px"
                v-model="queryInfo.latitude"
                :disabled="true"
              ></el-input>
              <span style="margin-left: 10px; margin-right: 10px">经度</span>
              <el-input
                label="纬度"
                style="width: 150px"
                v-model="queryInfo.longitude"
                :disabled="true"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="位置" :visible.sync="isLocationShow" class="dialog" ref="map-dialog">
      <location :locationName="locationName" ref="location" :latitude="queryInfo.latitude" :longitude="queryInfo.longitude"></location>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">取 消</el-button>
        <el-button type="primary" @click="confirmClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { signInInsert, signInUpdate } from "../../api/serviecRequestSignIn";

import Location from "../../components/Location.vue";

export default {
  components: {
    Location,
  },
  name: "NewMeetingSignIn",
  data() {
    return {
      username: "",
      queryInfo: {
        id: "",
        eventName: "",
        eventId: '',
        relationId: "",
        startTime: "",
        endTime: "",
        sponsor: "",
        coOrganizer: "",
        organizer: "",
        activityAddress: "",
        latitude: 0,
        longitude: 0,
      },
      preventDbClick: true,
      isLocationShow: false,
      locationName: "",
      isPositionCorrect: false,
    };
  },

  methods: {
    goIndex() {
      this.$router.back();
    },
    async addNewServer() {
      if (this.preventDbClick === true) {
        let obj = Object.assign({}, this.queryInfo);
        if (obj.eventName == "") {
          this.$message.error("活动名称为必填！");
          return;
        } else if (obj.activityAddress == "") {
          this.$message.error("活动地址为必填！");
          return;
        } else if (this.isPositionCorrect) {
          this.$message.error("请先确定位置后保存");
          return;
        } else if (obj.startTime == "") {
          this.$message.error("请选择开始时间");
          return;
        } else if (obj.endTime == "") {
          this.$message.error("请选择结束时间");
          return;
        } 

        this.preventDbClick = false;
        try {
          let IfUpdate = this.$route.query.data === undefined;
          let note = IfUpdate ? "确定新增该会议？" : "确定提交修改？";
          let res;
          await this.$confirm(note, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
          if (!IfUpdate) {   
            res = await signInUpdate(obj);
          } else {
            res = await signInInsert(obj);
          }
          if (res.status == 200) {
            let { id } = res.result;
            this.$message({
              message: IfUpdate
                ? "添加数据成功,1s后跳转到首页"
                : "修改数据成功,1s后跳转到首页",
              type: "success",
            });
            this.timed = setTimeout((_) => {
              this.$router.push({
                name: "IndexSignIn",
              });
            }, 1000);
          }
        } catch (error) {
          this.preventDbClick = true;
        }
      }
    },
   
    cancel() {
      this.$router.go(-1);
    },
    queryLocation() {
      if (this.queryInfo.activityAddress === "") {
        this.$message.error({
          message: "请先填写活动地址",
        });
        return;
      }
      this.isLocationShow = true; //弹出弹窗
      this.locationName = this.queryInfo.activityAddress; //保存在输入框输入的地址
    },

    confirmClick() {
      this.isLocationShow = false;
      this.isPositionCorrect = false;

      const { latitude, longitude } = this.$store.state.location;
      this.queryInfo.latitude = latitude;
      this.queryInfo.longitude = longitude;
    },

    cancelClick() {
      this.isLocationShow = false;
      this.isPositionCorrect = true;
    },

    addressChange(e) {
      this.isPositionCorrect = true
    }
  },
  beforeDestroy() {
    clearTimeout(this.timed);
  },
  mounted() {
    if (this.$route.query.data) {
      const info = JSON.parse(decodeURIComponent(this.$route.query.data));
      this.queryInfo = info;
    }

   
  },
  watch: {
    // "queryInfo.activityAddress"() {
    //   this.isPositionCorrect = true;
    // },
  },
};
</script>

<style scoped>

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 21.875rem;
}

.dialog >>> .el-dialog__body {
  padding: 0;
}
.dialog >>> .el-dialog {
   width: 700px !important
 }
</style>
